import React from "react";
import { ExternalLink, Newspaper, Facebook, Youtube, Twitter, Link2, Pin } from "lucide-react";

const ICON = { news: Newspaper, facebook: Facebook, youtube: Youtube, twitter: Twitter, other: Link2 };

export default function CoverageList({ items }) {
  if (!items?.length) return null;
  return (
    <div className="space-y-4" data-testid="coverage-list">
      {items.map((c) => {
        const Icon = ICON[c.coverage_type] || Link2;
        return (
          <a key={c.id} href={c.url} target="_blank" rel="noopener noreferrer"
            className="group flex items-start gap-4 py-4 border-b border-npst-line last:border-0 hover:bg-npst-goldLight/40 rounded-md px-2 -mx-2 transition-colors" data-testid="coverage-item">
            {c.image ? (
              <img src={c.image} alt="" loading="lazy" className="w-24 h-16 object-cover rounded-sm border border-npst-line shrink-0 bg-npst-bgAlt" onError={(e) => { e.currentTarget.style.display = "none"; }} />
            ) : (
              <div className="mt-1 text-npst-gold shrink-0"><Icon size={20} /></div>
            )}
            <div className="min-w-0 flex-1">
              <div className="flex items-center gap-2 text-[11px] font-sans font-bold uppercase tracking-[0.16em] text-npst-gold">
                <Icon size={12} /> {c.source || c.coverage_type}{c.date ? <span className="text-npst-muted font-medium normal-case tracking-normal">· {c.date}</span> : null}
                {c.pinned && <span className="inline-flex items-center gap-1 text-npst-navy font-semibold" data-testid="coverage-pinned-badge"><Pin size={10} /> Pinned</span>}
              </div>
              <div className="font-serif text-xl text-npst-ink group-hover:text-npst-navy transition-colors leading-snug mt-0.5">{c.title}</div>
              {c.description && <p className="text-sm text-npst-inkSoft mt-1 leading-relaxed line-clamp-2">{c.description}</p>}
              <span className="inline-flex items-center gap-1.5 mt-1.5 text-xs text-npst-navy font-semibold truncate max-w-full">
                {c.url.replace(/^https?:\/\//, "").slice(0, 60)} <ExternalLink size={12} />
              </span>
            </div>
          </a>
        );
      })}
    </div>
  );
}
